import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import LoadableRedux from '../../redux/ModuleLoaderLazy';
const LoadableModal = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "correspondence_modal" */ './CorrespondenceModal')));
const CorrespondenceModalLoadable = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "CorrespondenceModalLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            withOverlay: true,
            usePortal: true
        })
    }, /*#__PURE__*/ React.createElement(LoadableRedux, null), /*#__PURE__*/ React.createElement(LoadableModal, props)));
CorrespondenceModalLoadable.displayName = 'CorrespondenceModalLoadable';
export default CorrespondenceModalLoadable;

//# sourceMappingURL=CorrespondenceModalLoadable.js.map